import { useMutation } from "react-query";

import { useNotify } from "~/shared/hooks/useNotify";

import { useIvideon } from "./useIvideon";

export const useGetIvideonLicensesReport = () => {
  const { getIvideonLicensesReport } = useIvideon();
  const { notifyReport } = useNotify();
  const { data, isLoading, isError, mutate } = useMutation({
    mutationFn: () => getIvideonLicensesReport(),

    onSuccess: (response) => {
      const hash = response?.data?.fileHash;
      if (hash) {
        notifyReport(hash);
      }
    },
  });

  return {
    data: data?.data,
    isLoading: isLoading,
    isError: isError,
    getIvideonLicensesReport: mutate,
  };
};
